import React from 'react';
import { companyInfo } from '../data/mock';
import WhatsappIcon from '../components/ui/WhatsappIcon';

const FloatingWhatsApp = () => {
  const whatsappUrl = `${companyInfo.contact.phoneUrl}?text=${encodeURIComponent(
    'Olá! Estava navegando no site da 3M Solar e gostaria de tirar algumas dúvidas.'
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-[#25D366] text-white rounded-full shadow-[0_4px_12px_rgba(37,211,102,0.4)] hover:bg-[#20bd5a] hover:scale-110 transition-all duration-300 group animate-bounce-slow"
      aria-label="Falar conosco no WhatsApp"
    >
      <div className="absolute inset-0 w-full h-full rounded-full bg-[#25D366] animate-ping opacity-25"></div>
      <WhatsappIcon className="w-8 h-8 relative z-10" />
      
      {/* Tooltip */}
      <div className="absolute right-20 bg-white text-gray-800 text-sm font-semibold px-4 py-2 rounded-2xl shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap border border-gray-100">
        Fale com um Especialista
        <div className="absolute right-[-6px] top-1/2 transform -translate-y-1/2 w-3 h-3 bg-white rotate-45 border-r border-t border-gray-100"></div>
      </div>
    </a>
  );
};

export default FloatingWhatsApp;
